import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DateTimeConvertService } from "src/app/services/CommonService/DateTimeConvert.service";
import { AppComponent } from "src/app/app.component";
import { tConsultHeadModelWithPatientInfo } from "src/app/models/tConsultHeadModel";
import {
  tBillPayModelWithItemCateInfo,
  BillPay_ItemType,
} from "src/app/models/tBillPayModel";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import {
  Input,
  Component,
  OnInit,
  Inject,
  LOCALE_ID,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { BillPay_PaymentMethod_Class } from "src/app/models/tPaymentModel";
import { SelectionModel } from "@angular/cdk/collections";
import { DatePipe, formatCurrency } from "@angular/common";
import { AppCurrencyPipeModule } from "src/app/services/CommonService/custom.currency.pipe";
import { NavigationComponent } from "src/app/pages/navigation/navigation.component";
import { AppSettings } from "src/app/shared/AppSettings";
import { json } from "express";
import { tShopService } from "src/app/services/tShop.service";
import { tEmployeeService } from "src/app/services/tEmployee.service";
import { tItemCateService } from "src/app/services/tItemCate.service";
import { tItemCateModel } from "src/app/models/tItemCateModel";
import { isNullOrUndefined, isUndefined } from "util";
import { forEach } from "@angular/router/src/utils/collection";
import { setDOM } from "@angular/platform-browser/src/dom/dom_adapter";
import { tPurchaseOrderService } from "src/app/services/tPurchaseOrder.service";
import { pointInsideRect } from "@fullcalendar/core/util/geom";
import { tPurchaseOrderModel } from "src/app/models/tPurchaseOrderModel";
import { tVendorService } from "src/app/services/tVendor.service";
import { type } from "os";
import { tWhseService } from "src/app/services/tWhse.service";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "app-purchase-order-hardcopy",
  templateUrl: "./purchase-order-hardcopy.component.html",
  styleUrls: ["./purchase-order-hardcopy.component.css"],
})
export class PurchaseOrderHardcopyComponent implements OnInit {
  @Input() poNumber: string;

  shopInfo = {
    name_tc: "",
    name_en: "",
    address_tc: "",
    address_en: "",
    tel: "",
    email: "",
  };

  poInfo = {
    shopID: "",
    poNumber: "",
    poDate: new Date(),
    vendorCode: "",
    vendorName: "",
    vendorAddress: { a1: "", a2: "", a3: "" },
    products: {},
    totalAmt: 0,
    contactPerson: "",
    remark: "",
  };

  totalPage = 0;
  
  PrintReady = {
    ableToPrint : false,
    startID : 0,
    endID : 3
  }

  constructor(
    public activeModal: NgbActiveModal,
    private dateTimeConvertService: DateTimeConvertService,
    private datepipe: DatePipe,
    private tShopService: tShopService,
    private tEmployeeService: tEmployeeService,
    private tItemCateService: tItemCateService,
    @Inject(LOCALE_ID) public locale: string,
    private PoService: tPurchaseOrderService,
    private VendorService: tVendorService,
    public translate : TranslateService
  ) {}

  ngOnInit() {
    this.getShopInfo(NavigationComponent.selectedShopID.toString());
    //get po info
    this.PoService.getSavedPO(
      NavigationComponent.selectedShopID.toString(),
      this.poNumber
    ).subscribe((data) => {
      const head = data[0];
      this.poInfo.poNumber = head.poNumber;
      this.poInfo.poDate = head.poDate;
      this.poInfo.remark = head.poLineRemark;
      this.poInfo.vendorCode = head.poVendorCode;
      this.poInfo.vendorName = head.poVendorName;
      this.poInfo.shopID = head.shopID;
      this.poInfo.totalAmt = head.poAPAmt; //total amount

      this.VendorService.getDataById(head.poVendorCode).subscribe((data) => {
        this.poInfo.vendorAddress.a1 = data.vendorAddress1;
        this.poInfo.vendorAddress.a2 = data.vendorAddress2;
        this.poInfo.vendorAddress.a3 = data.vendorAddress3;
        this.poInfo.contactPerson = data.vendorContact;
        this.preparePrintProcessDone();
      });

      //total page
      this.totalPage = this.getTotalPage(data);

      //each page products
      console.log("products type = " + typeof this.poInfo.products);
      const prodLen = data.length;
      const maxProduct = 8;
      const blankProduct = new tPurchaseOrderModel();
      const prefix = "p";
      let suffix = 1;

      if (prodLen <= maxProduct * 1) {
        // 0-7
        this.poInfo.products[prefix + suffix] = data.slice(maxProduct * (suffix-1));

      }else{
        this.poInfo.products[prefix + suffix] = data.slice(0, maxProduct);

        while(suffix != (this.totalPage - 1)){
          suffix++;
          this.poInfo.products[prefix + suffix] = data.slice(maxProduct * (suffix-1) , maxProduct * suffix);
        }

        suffix++;
        this.poInfo.products[prefix + suffix] = data.slice(maxProduct * (suffix-1));

      }

      console.log('last: this.poInfo.products['+prefix+suffix+'] = '+this.poInfo.products[prefix+suffix].length);

      while (this.poInfo.products[prefix + suffix].length != 8) {
        this.poInfo.products[prefix + suffix].push(blankProduct);
      }

      this.preparePrintProcessDone();

    });
  }

  getTotalPage(data: tPurchaseOrderModel[]) {
    const len = data.length;
    const max = 8;
    let pointer = max;
    let res = 1;

    while (len > pointer) {
      pointer += max;
      res += 1;
    }

    return res;
  }

  getProducts(page: number) {
    const prefix = 'p';
    const suffix = page + 1;
    return this.poInfo.products[prefix + suffix];
  }

  cancel() {
    this.activeModal.close("Close click");
  }

  preparePrintProcessDone(){
    this.PrintReady.startID++;
    if(this.PrintReady.startID === this.PrintReady.endID) this.PrintReady.ableToPrint = true;
  };

  getShopInfo(shopID: string) {
    this.tShopService.getDataById(shopID).subscribe(
      (res: any) => {
        this.shopInfo.address_tc =
          res.shopAddress1 + res.shopAddress2 + res.shopAddress3;
        this.shopInfo.address_en =
          res.shopAddressEng1 + res.shopAddressEng2 + res.shopAddressEng3;
        this.shopInfo.tel = res.shopPhone;
        this.shopInfo.email = res.shopEmail;
        this.shopInfo.name_en = res.shopNameEng;
        this.shopInfo.name_tc = res.shopName;

        this.preparePrintProcessDone(); //prepare print work done

      },
      (err) => {
        console.log(err);
      }
    );
  }
}
